var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container home"},[_c('slider',{attrs:{"options":_vm.sliderOption}}),_c('about'),_c('skills'),_c('experience'),_c('education'),_c('certification'),_c('contact')],1)}
var staticRenderFns = []

export { render, staticRenderFns }